import useStoreSchema from 'lib/reusable-components/reusableUtils/commons/useStoreSchema';
import { mls } from 'lib/multilanguagesupport';
import React, { useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import reduxConstants from 'lib/reusable-components/reusableUtils/redux/reduxConstants';
import { KTSVG } from '_metronic/helpers';
import SheetSettings from './SheetSettings';
import NoAssetScreen from 'lib/reusable-components/noAssetScreens/NoAssetScreen';
import Sorting from 'lib/data-connectors/dependencies/Sorting';

function AllSheets(params) {
  const [isModalOpen, setModalOpen] = useState(null);
  const history = useHistory();
  const { appID } = useParams();
  const analyticsSchema = useStoreSchema(
    reduxConstants.STORE_NAME,
    reduxConstants.config.ANALYTICS_SCHEMA
  );
  const accessType = analyticsSchema?.appAccess?.accessType || [];
  const isAccess =
    accessType.includes('ALLOWED_ALL') ||
    accessType.includes('ALL_CREATOR') ||
    accessType.includes('CHART_CREATOR');
  const [sheetSchema, setSheetSchema] = useState(analyticsSchema?.appSheets || {});
  const [searchKeyWord, setSearchKeyWord] = useState('');

  const handleButton = (sheetID) => {
    history.push(`/${appID}/sheets/${sheetID}/`);
  };

  const getNoOfCharts = (sheetID) => {
    const sheet = sheetSchema[sheetID] || {};
    const count = sheet?.charts?.length || 0;
    return count;
  };

  // showing an error message if there is no dashboard added.
  if (Object.keys(analyticsSchema?.appSheets || {}).length === 0)
    return <NoAssetScreen assetType='Sheet' />;

  return (
    <>
      <div className='d-flex justify-content-end align-items-center mb-3 p-5 bg-white rounded'>
        <Sorting
          setObjectOfObjects={setSheetSchema}
          dataInRedux={analyticsSchema?.appSheets}
          keyProperty={'sheetID'}
          searchBy={'name'}
          updateSearchKey={setSearchKeyWord}
        />
      </div>

      <div className='row g-6 g-xl-9'>
        {Object.keys(sheetSchema).length === 0 ? (
          <div class='alert alert-warning m-auto mt-10' role='alert' style={{ width: '98%' }}>
            {`${mls('No Sheet found for the keyword:')} ${searchKeyWord}.`}
          </div>
        ) : (
          Object.keys(sheetSchema).map((sheetID, sheetIndex) => (
            <div className='col-lg-6 col-xxl-4' key={`${sheetID}-${sheetIndex}`}>
              <div className='card card-supista'>
                <div className='card-body'>
                  {/* Project Title */}
                  <div className='d-flex justify-content-between align-items-center'>
                    <Link to={'#'} onClick={(e) => e.preventDefault()}>
                      <div className='fs-4 fw-bolder' onClick={() => handleButton(sheetID)}>
                        {mls(sheetSchema[sheetID].name)}
                      </div>
                    </Link>
                    <button
                      type='button'
                      className='btn btn-clean btn-sm btn-icon btn-icon-primary btn-active-light-primary me-n3'
                      onClick={() => setModalOpen(sheetID)}
                    >
                      <KTSVG
                        path='/media/icons/duotune/general/gen024.svg'
                        className='svg-icon-3 svg-icon-primary'
                      />
                    </button>
                  </div>
                  {isAccess && isModalOpen === sheetID && (
                    <SheetSettings
                      key={sheetID}
                      appID={appID}
                      sheetID={sheetID}
                      isModalOpen={isModalOpen}
                      setModalOpen={setModalOpen}
                      isNew={false}
                      sheetSchema={sheetSchema[sheetID]}
                    />
                  )}
                  {/* Project Description */}
                  {/* <Link to={getLink(project)}> */}
                  <div
                    className={
                      'fs-5 fw-bold text-gray-400 ' +
                      (sheetSchema[sheetID].description ? 'text-truncate mb-2' : 'mb-9')
                    }
                    onClick={() => handleButton(sheetID)}
                    style={{ cursor: 'pointer' }}
                  >
                    {mls(sheetSchema[sheetID].description)}
                  </div>
                  {/* </Link> */}
                  {/* Project Icon */}
                  <div className='d-flex flex-wrap'>
                    <div className='d-flex flex-center h-80px w-80px me-15'>
                      <div className='symbol symbol-75px symbol-circle'>
                        <span
                          className={`symbol-label bg-light-primary text-primary fs-2hx fw-bolder`}
                        >
                          {sheetSchema[sheetID]?.name?.charAt(0) || ''}
                        </span>
                      </div>
                    </div>
                    {/* Project Details */}
                    <div className='d-flex flex-column justify-content-center flex-row-fluid pe-2 mb-0'>
                      {/* <div className='d-flex fs-6 fw-bold align-items-center mb-3'>
                    <div className='bullet bg-primary me-3'></div>
                    <div className='text-gray-400'>{mls('Total Sections')}</div>
                    <div className='ms-auto fw-bolder text-gray-700'>
                      {(sheetSchema[sheetID]?.sections || []).length}
                    </div>
                  </div> */}
                      <div className='d-flex fs-6 fw-bold align-items-center mb-5 justify-content-end'>
                        <div className='bullet bg-success me-3'></div>
                        <div className='text-gray-400'>{mls('Total Charts')}</div>
                        <div className='ms-auto fw-bolder text-gray-700'>
                          {getNoOfCharts(sheetID)}
                        </div>
                      </div>
                      <div className='d-flex fs-6 fw-bold justify-content-end'>
                        {/* <Link to={getLink(project)}> */}
                        <button
                          type='button'
                          className='btn btn-light-primary fw-bolder btn-sm me-n3'
                          data-kt-menu-trigger='click'
                          data-kt-menu-placement='bottom-end'
                          data-kt-menu-flip='top-end'
                          onClick={() => handleButton(sheetID)}
                        >
                          {mls('Go To Sheet')}
                        </button>
                        {/* </Link> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
}

export default AllSheets;
